<template>
    <div v-if="outages.length > 0 && adminDtls"  class="alert alert-danger fade show outage_banner">
        <ul class="list-inline outages_top_bar">
            <li><strong>Outages:</strong></li>
            <li v-for="(outage, index) in outages" :key="outage.url + '_' + index">
                {{outage.url}}
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "OutageBanner",
        data(){
            return {
                adminDtls: JSON.parse(localStorage.getItem('adminDtls'))
            }
        },
        computed: {
            outages(){
                const outages = this.$store.getters['notification/getAllOutages'];
                return outages.filter(el => el.type !== 'diskAlert');
            }
        }
    }
</script>

<style scoped>
.outage_banner{
    margin: 0 30px 20px;
    top: 0;
    overflow: auto;
}
.outage_banner ul{
    display: inline-flex;
    margin-bottom: 0
}
.outage_banner ul li{
    margin-left: 10px
}

</style>
